export default {
    fundattio_main_url: 'https://innogement-dev.vbote.com',
 		fundattio_service_url : 'https://innogement-dev.vbote.com/api/v1/',
    fundattio_gtag_id: 'X-XXXXXXXXXX',
    version: '1.0.0'
};